import withIcon from './NewIcon';
// @ts-ignore
import IconFrequentFoodies from './icon/l/frequentfoodies.s.svg';

export default withIcon(IconFrequentFoodies);
